<template>
    <div v-if="change" class="change-card">
        <span class="change-card-dot" />
        <div class="change-card-body">
            <div class="change-card-hdr">
                <span class="change-card-name">{{ change.name }}</span>
                <span class="change-card-block">{{ $tc('common.blocks', 1) }} {{ change.block }}</span>
            </div>
            <exercise-change-boxes :changes="change.groups" @click:video="$emit('click:video', $event)" />
        </div>
    </div>
</template>

<script>
import ExerciseChangeBoxes from "@/components/common/ExerciseChangeBoxes"

export default {
    name: "ChangeExerciseCard",
    components: { ExerciseChangeBoxes },
    props: {
        change: {
            type: Object,
            default: null
        },
    },
}
</script>

<style scoped>
.change-card {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 12px 14px;
}

.change-card-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--v-primary-base);
    flex-shrink: 0;
    margin-top: 5px;
}

.theme--light .change-card-dot {
    background: var(--v-accent-base);
}

.change-card-body {
    flex: 1;
    min-width: 0;
}

.change-card-hdr {
    margin-bottom: 10px;
}

.change-card-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.change-card-block {
    font-size: 11px;
    font-weight: 500;
    color: var(--v-txtMuted-base);
    margin-left: 6px;
}
</style>
